export const userInfoData = state => {
  if (!state.profile.data) return {}

  return state.profile.data
}
